import { render, staticRenderFns } from "./imgBackground.vue?vue&type=template&id=a40719c0&scoped=true&"
import script from "./imgBackground.vue?vue&type=script&lang=js&"
export * from "./imgBackground.vue?vue&type=script&lang=js&"
import style0 from "./imgBackground.vue?vue&type=style&index=0&id=a40719c0&prod&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "a40719c0",
  null
  
)

export default component.exports